import React, { useContext, useEffect, useMemo, useState } from 'react';
import { ErrorContext } from "../../../components/GympinPagesProvider";
import Slick from "react-slick";
import { Box, Skeleton } from "@mui/material";
import { getListByViewType, getQueryResults } from "./_ep_queries";

const _ep_CAROUSEL_SIMPLE_LIST = ({ carousel }) => {
    const error = useContext(ErrorContext);
    const isStatic = !carousel?.Items?.[0]?.Type?.startsWith("QUERY");
    const [items, setItems] = useState(() => isStatic ? carousel?.Items : null);
    const itemType = carousel?.Items?.[0]?.ViewType;
    const carouselId = carousel?.Id || carousel?.Description;

    useEffect(() => {
        if (!carousel) return;
        if (isStatic && carousel?.Items) {
            setItems(carousel.Items);
            return;
        }

        let isMounted = true;
        getQueryResults(carousel, error)
            .then(result => {
                if (isMounted) setItems(result);
            })
            .catch(e => {
                console.error("Carousel query error:", e);
            });

        return () => {
            isMounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [carouselId, isStatic]);

    const slickSettings = useMemo(() => {
        let parsed = {};
        try {
            if (carousel?.Data) {
                parsed = typeof carousel.Data === "object" ? carousel.Data : JSON.parse(carousel.Data);
            }
        } catch {
            parsed = {};
        }

        return {
            rtl: true,
            swipeToSlide: true,
            arrows: false,
            dots: false,
            ...parsed
        };
    }, [carousel?.Data]);

    const displayItems = useMemo(() => {
        if (!items || !items.length) return [];
        if (items.length >= 4) return items;
        let list = items;
        while (list.length < 4) {
            list = [...list, ...items];
        }
        return list.slice(0, 4);
    }, [items]);

    if (!items) {
        return (
            <Box sx={{ px: { xs: 1.5, sm: 2 }, my: 2 }}>
                <Skeleton
                    variant="rounded"
                    animation="wave"
                    height={260}
                    sx={{ width: "100%", borderRadius: "20px" }}
                />
            </Box>
        );
    }

    return (
        <Box sx={{ px: { xs: 0.5, sm: 1 }, my: 1.5, overflow: "hidden" }} dir="rtl">
            <Slick {...slickSettings}>
                {displayItems?.map((item, index) => getListByViewType(itemType, item, index))}
            </Slick>
        </Box>
    );
};

export default React.memo(_ep_CAROUSEL_SIMPLE_LIST);

